import React from "react";
import { Link } from "react-router-dom";

class DestinationBanner extends React.Component {
  render() {
    return (
      <div className="banner get-wifi-us-banner">
        <div className="item">
          <img
            className="first-slide img-responsive"
            src={this.props.bannerImg}
            alt="destination"
          />
          <div className="container">
            <div className="carousel-caption">
              <h1>Destination: {this.props.bannerTitle}</h1>
            </div>
            <div className="banner-content">
              <div className="banner-content-left">
                AS LOW AS
                <br />
                <span>$9</span>
              </div>
              <div className="banner-content-right">
                connect Up to <br />
                10 devices
                <br />
                Unlimited Data
                <br />
                No Contract
              </div>
            </div>
            <div className="buttons">
              <Link className="red-btn" to="/buy">
                BUY
              </Link>
              <Link className="blue-btn" to="/rent">
                RENT
              </Link>
            </div>
          </div>
          <div className="bottom-text">
            See Mighty benefits and how it works{" "}
            <Link to="/sale">
              <i className="fa fa-chevron-circle-right" />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default DestinationBanner;



// WEBPACK FOOTER //
// ./src/reusable/DestinationBanner.js